import React from "react";
import { Link } from "react-router-dom";

export default function RelatedArticles({ posts }) {
  if (!posts || posts.length === 0) return null;

  return (
    <div className="mt-16 pt-8 border-t border-stroke">
      <h2 className="text-26 font-medium text-secondary mb-6">Related Articles</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {posts.map((post) => (
          <Link
            key={post._id}
            to={`/blog/${post.slug}`}
            className="group"
          >
            <article className="bg-white rounded-lg overflow-hidden border border-stroke hover:shadow-lg hover:border-primary/20 transition-all duration-300">
              {post.featuredImage && (
                <div className="relative overflow-hidden h-40">
                  <img
                    src={post.featuredImage}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
              )}
              <div className="p-4">
                <h3 className="text-16 font-medium text-secondary group-hover:text-primary transition-colors line-clamp-2 mb-2">
                  {post.title}
                </h3>
                <p className="text-12 text-light-gray line-clamp-2">
                  {post.excerpt}
                </p>
              </div>
            </article>
          </Link>
        ))}
      </div>
    </div>
  );
}
